import React from "react";
import { Col, Container, Row } from "react-bootstrap";

export default function Internet() {
  return (
    <div className="internet-container">
      <Container>
        <div className="newsSection">
          <div className="newsTitle">Ogłoszenie</div>
          <br />
          <div className="newsDescription">
             W dniu 27.01.2026r. została zerwana linia średniego napięcia przez
firmę wykonującą przyłącze gazowe. Brak dostępu do internetu odnotowano
w miejscowościach Inczew, Dzierlin, Charłupia Mała, Biskupice, Małków,
Bartochów, Piotrowice. 
          </div>
          <br />
          <div className="newsDescription2">Jesteśmy w trakcie usuwania usterki. Prosimy o
cierpliwość.</div>
          <div className="newsSignature">
            <br />
            Za utrudnienia przepraszamy, zespół a-Media.
          </div>
        </div>
        <Row>
          <Col>
            <div className="internet-heading">
              <h2>Internet światłowodowy</h2>
            </div>
          </Col>
        </Row>
        <Row>
          <Col>
            <div className="internet-text-box">
              <h3>Oferta dla każdego</h3>
              <p>
                Niezależnie od tego czy jesteś klientem indywidualnym czy
                posiadasz swoją firmę, jesteśmy w stanie przedstawić Ci ofertę,
                która spełni Twoje wymagania. Oferujemy łącza światłowodowe oraz
                bezprzewodowe od 79zł.
              </p>
            </div>
          </Col>
          <Col>
            <div className="internet-text-box">
              <h3>Najwyższa wydajność i niezawodność</h3>
              <p>
                Dzięki temu, że mamy dostęp do łącz operatorskich przez
                zbudowane przez nas sieci światłowodowe jesteśmy w stanie tak
                optymalizować sieć, aby uzyskać najwyższą wydajność.
              </p>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}
